/* eslint-disable prefer-spread */
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';

export const getNewSlugURL = (slugs, path, locale) => {
  const newPath = [];
  let isNewPath = false;
  slugs.forEach((slug) => {
    if (slug.new_slug) {
      newPath.push(encodeURIComponent(slug.new_slug));
      isNewPath = true;
    } else {
      newPath.push(encodeURIComponent(slug.slug));
    }

    return null;
  });
  if (isNewPath) {
    if (locale) {
      return getLocalizedUrl(path?.apply(null, newPath).url, locale);
    }
    return path?.apply(null, newPath);
  }
  return null;
};
